import * as React from 'react';
import {
    GridColumnMenuCheckboxFilter
} from '@progress/kendo-react-grid';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import esMessages from './tlklang.json';

export class ColumnMenu extends React.Component {
  
    render() {
      
        return (
          <LocalizationProvider language="pt-PT">
            <IntlProvider locale="pt">
            <div>
                <GridColumnMenuCheckboxFilter {...this.props} data={this.props.data} expanded={true} placeholder="Custom Placeholder Text"/>
            </div>
            </IntlProvider>
            </LocalizationProvider>
        );
       
    }
}
